<template>
	<div :class="rulesList.length>0?'con_b':'con_b_normal'">
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="图书详情" goBack="true"></head-top>

		<div class="cover_image">
			<div class="cella">
				<van-swipe :autoplay="3000" :show-indicators="false">
					<van-swipe-item v-for="(item ,index) in imgs" :key="index">
						<img :src="resourceDomain+item" class="cella" />
					</van-swipe-item>
				</van-swipe>
			</div>

			<div class="mask flex_a">
				<div class="img_bottom color_b font_size_c fw">
					文武教师出品
				</div>
			</div>
		</div>

		<div class="detail_top">
			<div class="color_a fw detail_title ">
				{{bookDetail.title}}
			</div>
			<div class="detail_sketch font_size_b color_f" v-if="bookDetail.sketch">
				{{bookDetail.sketch}}
			</div>
			<div class="tips_list flex_a font_size_e">
				<div class="tips_b tips_item">
					{{bookDetail.navId==0?'通用图书':bookDetail.navName}}
				</div>
				<div class="tips_a tips_item" v-if="bookDetail.categoryType!=0">
					{{bookDetail.categoryTypeName}}
				</div>
				<div class="tips_c tips_item" v-if="bookDetail.categorySubject!=0">
					{{bookDetail.categorySubjectName}}
				</div>
				<div class="tips_d tips_item" v-if="bookDetail.categoryGrade!=0">
					{{bookDetail.categoryGradeName}}
				</div>
				<div class="tips_e tips_item" v-if="bookDetail.areaId!=0">
					{{bookDetail.areaName}}
				</div>
				<div class="tips_f tips_item" v-if="bookDetail.specialOfferStatus">
					特价图书
				</div>
			</div>
			<div class=" flex_a font_size_e">
				<div class="tips_f tips_item" v-if="discountString.length>0">
					{{discountString}}
				</div>
			</div>

			<!-- 图书售卖截止日期 -->
			<div v-if="bookDetail.expiredTime" class="color_d font_size_e">
				购买截止日期：{{(bookDetail.expiredTime).substr(0, 10)}}
			</div>
		</div>

		<div v-if="shareBgPic" class="share_cell bg_a tabcell" @click="distributionShare">
			<img :src="resourceDomain+shareBgPic" class="share_bg" />
			<div class="amount_money" :style="{'color':fontColor}">
				<span>￥</span>{{amount}}
			</div>
		</div>

		<div>
			<div class="bg_a tabcell">
				<div class="content_tab flex_b color_e font_size_c fw" style="width: 100%;">
					<div class="tab_item" :class="tab_index==0?'active':''" @click="choose_tab(0)">图书详情</div>
					<div class="tab_item" :class="tab_index==1?'active':''" @click="choose_tab(1)">用户评价</div>
				</div>

				<!-- tab对应内容 -->
				<div class="tabcontentcell">
					<!-- 图书详情 -->
					<div v-if="tab_index==0" v-html="info" class="book_details color_a font_size_c"></div>

					<!-- 用户评价 -->
					<div v-if="tab_index==1" class="detail_comment_list">
						<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
							<van-list :offset="40" v-model="loading" :finished="finished" :immediate-check="false"
								:finished-text="finishedText" @load="onLoad">
								<div v-if="commentsList.length>0">
									<div v-for="(item, index) in commentsList" :key="index">
										<div class="detail_comment_list_item bg_a">
											<!-- 已删除遮罩 delete：0未删除，1已删除，2过渡待删除-->
											<div class="detail_comment_list_deleteMask flex_d" v-if="item.deleted==2">
												<img :src="require('../../assets/img/deleted.png')">
											</div>

											<!-- 头像，昵称，发表时间,删帖 -->
											<div class="flex_c detail_comment_list_userinfo">
												<img :src='item.user.customAvatar?resourceDomain+item.user.customAvatar:default_avatar'>
												<div class="flex_c detail_comment_list_userright">
													<div class="color_a font_size_c ellipsis_1" style="width:100%;">
														{{item.user.realName?item.user.realName:item.user.loginAccount}}</div>
													<div class="color_e font_size_b ellipsis_1" style="width:100%;">{{item.createTime}}</div>
												</div>
											</div>

											<!-- 评论-文字 -->
											<div class="color_a font_size_a detail_comment_list_txt"
												@click="toCommentDetail(item.id,item.deleted)">
												<div v-html="item.comment?item.comment:'用户未填写评价'" class="ellipsis_4"></div>
											</div>

											<!-- 评论-多图 -->
											<div class="flex_a detail_comment_list_imgs" v-if="item.imgs">
												<div v-for="(t,idx) in item.imgs.split(',')" :key='idx' class="detail_comment_list_img_item">
													<img :src='resourceDomain+t' v-if="t" @click="previewImages(item.imgs.split(','),idx)"></img>
												</div>
											</div>

											<div class="flex_c font_size_b detail_comment_list_btns" style="width: 100%;"
												v-if="item.canDelete||item.officialStatus">
												<!-- 删帖 -->
												<div>
													<div class="flex_a color_d" @click="removeComment(item.id,index)" v-if="item.canDelete">
														<img :src='resourceDomain+"static/icon/clear-his.png"'>
														<div>删除该条评论</div>
													</div>
												</div>
												<!-- 答复 -->
												<div class="color_c flex_a" v-if="item.officialStatus"
													@click="toCommentDetail(item.id,item.deleted)">
													<img :src='require("../../assets/img/books/reply.png")'>
													<div>点击查看回复</div>
												</div>
											</div>

										</div>
									</div>
								</div>


								<div class="color_e font_size_c padding_top_b" style="text-align:center;" v-else>
									暂无数据
								</div>
							</van-list>
						</van-pull-refresh>
					</div>

				</div>
			</div>
		</div>

		<!-- 分销分享二维码弹窗 -->
		<van-popup v-model="showQrCode" style="width: 80vw;height:126vw;overflow: hidden;">
			<div class="qrCodeTips fw color_d">
				长按保存海报，分享好友购买，赚取奖励
			</div>
			<vue-canvas-poster :widthPixels="1000" :painting="painting" @success="canvasSuccess"
				@fail="canvasFail"></vue-canvas-poster>
			<img style="width: 80vw;height:116vw;" :src="posterImg" alt="">
		</van-popup>

		<!-- 底部 -->
		<div class="book_bottom">
			<!-- 退款说明、用户守则等守则名 -->
			<van-notice-bar left-icon="volume-o" :scrollable="false" v-if="rulesList.length>0">
				<van-swipe vertical class="notice-swipe_a" :autoplay="3000" :touchable='false' :show-indicators="false">
					<van-swipe-item class="ellipsis_1" v-for="item in rulesList" :key='item.id' @click="showRulesPop(item.id)">
						《{{item.title}}》
					</van-swipe-item>
				</van-swipe>
			</van-notice-bar>

			<div class="buyBookAbout flex_c">
				<div class="flex_d left_price font_size_d">
					<div style="width:100%" class="color_d">
						<div v-if="bookDetail.specialOfferStatus">￥<span
								class="font_size_f fw">{{bookDetail.specialOfferPrice}}</span><span class="color_f font_size_d"
								style="text-decoration: line-through;">￥{{bookDetail.price}}</span></div>
						<div v-else>￥<span class="font_size_f fw">{{bookDetail.price}}</span></div>
					</div>
					<div class="color_g" style="width:100%">销量:{{bookDetail.sellCount>999?'999+':bookDetail.sellCount}}件<span
							style="color:#666">（库存:{{bookDetail.stockNumber===null?'999+':(bookDetail.stockNumber>999?'999+':bookDetail.stockNumber)}}）</span>
					</div>
				</div>
				<div class="rightbtns flex_c">
					<div class="tobuy_b color_b font_size_c" @click="addToCart(bookDetail.id)">加入购物车</div>
					<div class="tobuy_a color_b font_size_c" @click="tobuy(bookDetail.id)">立即购买</div>
				</div>
			</div>

		</div>
		<!-- 购物车 -->
		<div class="cartcell" @click="tocart">
			<img :src='resourceDomain+"static/icon/cart.png"' class="carticon">
			<van-badge :content="cartnumber" max="99" class="cartnumber" />
		</div>

		<!-- 守则内容 -->
		<van-popup v-model="rulesPop" closeable close-icon="close" round close-on-popstate :style="{ width: '90%'}">
			<div class="rulesCell_a">
				<div class="rulesTitle_a font_size_c color_a">
					{{rulesDetail.title}}
				</div>
				<div class="font_size_b rulesDetail_a color_f" v-html="rulesDetail.content">
				</div>
			</div>
		</van-popup>

	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import tool from "@/common/tool";
	import {
		mapGetters,
		mapActions
	} from 'vuex';
	import Vue from 'vue';
	import {
		Dialog,
		ImagePreview,
		Toast,
		Empty,
		Popup
	} from 'vant';
	export default {
		name: 'BookDetail',
		components: {
			headTop: headTop
		},
		data() {
			return {
				default_avatar: "https://wenwu3.oss-cn-hangzhou.aliyuncs.com/static/default_avatar.jpg", //默认头像
				// 评论列表分页
				commentsList: [],
				page: 0,
				pages: undefined,
				isLoading: false,
				loading: false,
				finished: false,
				finishedText: "",

				tab_index: 0,
				resourceDomain: api.resourceDomain,
				bookId: undefined,
				imgs: [],
				bookDetail: {},
				info: "",
				token: undefined,
				cartnumber: 0, //购物车数量
				discountString: "", //满减活动

				distributorId: undefined, //分销员Id，自己
				distributorStatus: false, //是否为分销员
				canDistibute: false, //是否可以分销
				amount: null, //分销金额
				shareBgPic: null, //分销按钮背景图
				fontColor: null, //分销金额字体颜色
				pid: undefined, //上级分销员id
				showQrCode: false, //是否显示分销分享二维码弹窗
				qrCodeUrl: null, //二维码链接

				posterImg: '', //生成的海报图片路径
				painting: {
					width: `${document.documentElement.clientWidth*0.8}px`,
					height: `${document.documentElement.clientWidth*1.16}px`,
					background: '#ffffff',
					views: [{ // 背景图片
							type: 'image',
							url: "",
							css: {
								top: 0,
								left: 0,
								width: `${document.documentElement.clientWidth*0.8}px`,
								height: `${document.documentElement.clientWidth*1.16}px`,
							}
						},
						{ //二维码
							type: 'qrcode',
							content: '',
							css: {
								bottom: `${document.documentElement.clientWidth*0.035}px`,
								left: `${document.documentElement.clientWidth*0.065}px`,
								color: '#000',
								width: `${document.documentElement.clientWidth*0.15}px`,
								height: `${document.documentElement.clientWidth*0.15}px`,
								borderWidth: '0',
								borderColor: '#fff'
							},
						},
					],
				},
				rulesPop: false, //守则弹窗显示
				rulesList: [], //守则列表
				rulesDetail: {} //守则详情
			}
		},
		beforeRouteEnter(to, from, next) {
			// 添加背景色
			document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
			next()
		},
		beforeRouteLeave(to, from, next) {
			// 去除背景色
			document.querySelector('body').setAttribute('style', '')
			next()
		},
		created() {},
		computed: {
			...mapGetters('userModule', ['getToken'])
		},
		activated() {
			this.bookId = this.$route.query.bookId
			this.pid=this.$route.query.distributorId
			this.getAllRules()
			this.updatePage()
		},
		methods: {
			...mapActions("userModule", ["SET_OPENID"]),
			// 调用组件中的登录成功里的自定义的更新数据事件
			updatePage() {
				window.scrollTo(0, 0);
				this.token = this.getToken()
				this.rulesPop = false
				this.showQrCode = false
				this.qrCodeUrl = null
				this.posterImg = ""
				this.painting.views[0].url = ""
				this.painting.views[1].content = ""
				
				// 评论列表分页
				this.commentsList = [];
				this.page = 0;
				this.loading = true
				this.isLoading=false
				this.finished = false
				this.finishedText=''
				
				this.$toast.loading({
					overlay: true,
					message: '加载中...',
					duration: 0
				})
				if (this.token) {
					this.getBookShoppingNumber()
					if (this.pid) {
						this.bindUserDistributor(this.pid)
					}
				} else {
					this.cartnumber = 0
				}
				if (this.tab_index == 1) {
					this.getListByBookId()
				}
				this.getBookById()
			},

			// 打开对应守则的弹窗,显示守则内容
			showRulesPop(id) {
				this.rulesDetail = {}
				this.rulesPop = true
				api.post(`/p/bookRules/getOneByRulesId/${id}`, {}).then((res) => {
					console.log(res.data, "-----getOneByRulesId------");
					if (res.success) {
						this.rulesDetail = res.data
					} else {
						this.$toast(res.message);
					}
				});
			},
			// 获取图书所有守则
			getAllRules() {
				api.get('/p/bookRules/getAllRules', {}).then((r) => {
					console.log(r.data, "----getAllRules--------")
					this.rulesList = r.data
				})
			},
			// 成功生成海报
			canvasSuccess(src) {
				this.posterImg = src; //生成是base64格式的图片
				console.log(src, "--------------成功")
			},
			// 无法生成海报
			canvasFail(err) {
				console.log(err, "-----------------失败")
			},
			// 绑定分销员和用户
			bindUserDistributor(pid) {
				api.post(`/book/bindUserDistributor/${pid}`).then(res => {
					this.$toast.clear()
				})
			},
			// 点击购物车图标
			tocart() {
				if (this.getToken()) {
					this.$router.push({
						path: '/book_cart'
					})
				} else {
					// 没登录，去登录
					this.$store.commit('userModule/SET_login_popup_show', true)
				}
			},
			// 获取购物车数量
			getBookShoppingNumber() {
				api.get('/book/getBookShoppingNumber', {}).then(res => {
					if (res.success) {
						console.log(res.data, "getBookShoppingNumber")
						this.cartnumber = res.data
					} else {
						this.$toast(res.message)
					}
				})
			},
			// 点击加入购物车
			addToCart(bookId) {
				var _this = this
				if (this.getToken()) {
					api.get('/book/addBookToShoppingCart', {
						bookId: bookId
					}).then(res => {
						if (res.success) {
							this.$toast.success("添加成功！")
							this.cartnumber = Number(this.cartnumber) + 1
						} else {
							this.$toast(res.message);
							setTimeout(function() {
								_this.getBookById()
							}, 1000);
						}
					})
				} else {
					// 没登录，去登录
					this.$store.commit('userModule/SET_login_popup_show', true)
				}
			},
			// 立即购买
			tobuy(bookId) {
				// 判断是否登录
				if (this.getToken()) {
					// 登录了，跳转提交订单
					console.log(" 登录了，跳转提交订单")
					sessionStorage.setItem('CURRENT_WAITING_PAY_BOOK_ID', bookId)
					// 如果是在微信网页内支付，就需要先获取code，再用code获取openid
					if (tool.isWxEnv()) {
						let url = encodeURIComponent(api.aPI_BASE_URL + "/#/book_confirm_order")
						window.location.href = tool.getCOdeBySnsapiBase(url);
					} else {
						this.$router.push({
							path: '/book_confirm_order'
						})
					}
				} else {
					// 没登录，去登录
					this.$store.commit('userModule/SET_login_popup_show', true)
				}
			},
			// 选择tab（课程详情，课程目录，教师介绍）
			choose_tab(v) {
				this.tab_index = v
				this.commentsList = [];
				this.page = 0;
				this.loading = true
				this.finished = false

				if (v == 1) {
					this.$toast.loading({
						overlay: true,
						message: '加载中...',
						duration: 0
					})
					this.getListByBookId()
				}
			},
			// 获取图书评论列表
			getListByBookId() {
				let url = this.getToken() ? '/book/comment/getListByBookIdHasUserId' : '/p/book/comment/getListByBookId'
				let commentsList = this.commentsList;
				let page = this.page + 1;
				api.get(url, {
					page: page,
					size: 10,
					bookId: this.bookId
				}).then((res) => {
					this.$toast.clear();
					console.log(res, "-----获取图书评论列表------");
					if (res.code == 20000) {
						if (page <= res.data.pages) {
							if (res.data.comments.length > 0) {
								for (var i = 0; i < res.data.comments.length; i++) {
									commentsList.push(res.data.comments[i]);
								}

								this.commentsList = commentsList;
								this.page = page;
								this.pages = res.data.pages;
								// 加载状态结束
								this.isLoading = false
								this.loading = false
								// 设置是否可以继续上拉加载
								if (this.page == this.pages) {
									this.finished = true
								} else {
									this.finished = false
								}
								this.finishedText = "没有更多了~"
							} else {
								this.finished = true
								this.finishedText = ""
								this.commentsList = []
							}
						} else {
							this.finished = true
							this.finishedText = "没有更多了~"
						}
					} else {
						this.$toast(res.message);
					}
				});
			},
			// 预览多图
			previewImages(images, idx) {
				images.forEach((value, index) => {
					images[index] = this.resourceDomain + value
				});
				ImagePreview({
					images: images,
					startPosition: idx,
					loop: false
				});
			},

			/**下拉刷新 */
			onRefresh() {
				console.log("----")
				this.page = 0;
				this.commentsList = [];
				if (this.tab_index == 1) {
					this.getListByBookId()
				}
				this.isLoading = false;
			},
			/**上拉加载 */
			onLoad() {
				console.log("+++")
				if (this.page == this.pages) {
					this.$toast('没有更多咯~')
				} else {
					this.$toast.loading({
						overlay: true,
						message: "加载中...",
						duration: 0,
					});
					if (this.tab_index == 1) {
						this.getListByBookId()
					}
				}
			},

			// 删除评论
			removeComment(id, index) {
				this.$toast.loading({
					overlay: true,
					message: '删除中...',
					duration: 0
				})

				api.post(`/book/comment/removeById/${id}`, {}).then(res => {
					this.$toast.clear()
					console.log(res, "-----removeById------")
					if (res.success) {
						this.$toast.success('删除成功！');
						this.$set(this.commentsList[index], 'deleted', '2');
					} else {
						this.$toast.fail("删除失败，请刷新重试");
					}
				})
			},

			// 跳转评论详情
			toCommentDetail(id, deleted) {
				if (deleted != 0) {
					this.$toast.fail("该条评论已删除，请刷新");
					return false
				} else {
					this.$router.push({
						path: "/comment_detail",
						query: {
							id: id
						},
					});
				}
			},
			// 获取图书详情
			getBookById() {
				let url = this.getToken() ? '/book/getBookDetailById' : '/p/book/getBookDetailById'

				api.get(url, {
					bookId: this.bookId
				}).then(res => {
					this.$toast.clear()
					console.log(res.data, "-----getBookDetailById------")
					if (res.success) {
						let bookDetail = res.data.book
						let info = res.data.book.content
						let imgs = res.data.splitImgs

						this.bookDetail = bookDetail
						this.imgs = imgs
						this.info = info
						this.discountString = res.data.discountString //满减活动

						this.distributorId = res.data.distributorId //分销员Id
						this.distributorStatus = res.data.distributorStatus //是否为分销员
						this.canDistibute = res.data.canDistibute //是否可以分销
						if (res.data.amount != null && res.data.amount != 0 && this.canDistibute) {
							this.amount = res.data.amount.toFixed(2) //分销金额
							api.get('/p/bookDistributionPic/getPic', {}).then(r => {
								console.log(r.data, "----------------分销按钮背景图")
								this.shareBgPic = r.data.distributionPic
								this.fontColor = r.data.fontColor
							})
						} else {
							this.amount = res.data.amount
							this.shareBgPic = null
							this.fontColor = null
						}

						//设置微信分享
						//分享时候安卓会把#屏蔽掉导致分享失败
						let linkUrl = api.aPI_BASE_URL + '/?#/book_detail/?bookId=' + this.bookId
						let shareInfo = {
							img: this.resourceDomain + imgs[0],
							link: linkUrl,
							title: bookDetail.title,
							desc: bookDetail.sketch
						}
						console.log("shareInof....", shareInfo)
						this.wxJssdkConfig().then(() => {
							this.wxShareReady(shareInfo);
						})
					} else {
						this.$dialog.alert({
							title: '提示',
							message: res.message
						}).then(() => {
							this.$router.go(-1)
						});
					}
				})
			},

			// 打开分销分享入口
			distributionShare() {
				if(this.getToken()){
					this.painting.views[0].url = ""
					this.posterImg = ''
					this.showQrCode = true
					this.painting.views[0].url = this.resourceDomain + this.bookDetail.distributionPic + `?t=${new Date()}` //海报背景图
					this.qrCodeUrl = api.aPI_BASE_URL + '/?#/book_detail/?bookId=' + this.bookId + '&distributorId=' + this.distributorId
					this.painting.views[1].content = this.qrCodeUrl
				}else{
					this.$store.commit('userModule/SET_login_popup_show', true)
				}
			},

			wxJssdkConfig() {
				console.log("wxJssdkConfig...")
				console.log(location.href.split('#')[0])
				var _this = this;
				return new Promise((resolve) => {
					api.post('/p/user/getWxShareInfo', {
						url: location.href.split('#')[0]
					}).then((res) => {
						_this.$wx.config({
							debug: false, // 开启调试模式
							appId: res.data.appId, // 必填，公众号的唯一标识
							timestamp: res.data.timestamp, // 必填，生成签名的时间戳
							nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
							signature: res.data.signature, // 必填，签名
							jsApiList: [
								"updateAppMessageShareData", //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
								"updateTimelineShareData", //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
								"onMenuShareWeibo", //获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
							] // 必填，需要使用的JS接口列表
						})
						console.log("调用后台接口成功>>>>>>>>>>>>>>>>>>", res)
						resolve(res)
					}).catch((error) => {
						console.log(error)
					});
				})
			},

			/**微信jssdk分享方法 */
			wxShareReady(shareInfo) {
				console.log("进入微信jssdk分享方法.........")
				var _this = this;
				this.$wx.ready(() => {
					_this.$wx.updateAppMessageShareData({
						title: shareInfo.title, // 分享标题
						link: shareInfo.link, // 分享链接
						imgUrl: shareInfo.img,
						desc: shareInfo.desc,
					}, function(res) {
						window.console.log(res)
					});
					_this.$wx.updateTimelineShareData({
						title: shareInfo.title, // 分享标题
						link: shareInfo.link, // 分享链接
						imgUrl: shareInfo.img,
						desc: shareInfo.desc,
					}, function(res) {
						window.console.info(res)
					});
				})
				_this.$wx.error(function(res) {
					window.console.log(res)
					//config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
				});
			}
		}
	}
</script>

<style>
	.notice-swipe_a {
		height: 40px;
		line-height: 40px;
	}

	img {
		display: block !important;
	}

	.book_details img {
		max-width: 345px;
		width: 100%;
		display: block;
		margin: 10px 0;
		object-fit: contain;
		height: auto;
	}

	.book_details p {
		margin: 0;
		margin-block-start: 0;
		margin-block-end: 0;
		line-height: 23px;
	}
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
	.rulesCell_a {
		padding: 30px 20px;
	}

	.rulesTitle_a {
		text-align: center;
		line-height: 23px;
		margin-bottom: 15px;
	}

	.rulesDetail_a {
		line-height: 20px;
		max-height: 60vh;
		overflow-y: scroll;
		letter-spacing: 1px;
		white-space: pre-wrap;
	}

	.qrCodeCell img {
		padding: 20px;
	}

	.qrCodeBg {
		background: #fff !important;
	}

	.qrCodeTips {
		height: 10vw;
		line-height: 10vw;
		text-align: center;
		font-size: 14px;
		letter-spacing: 1px;
	}

	.tabcell {
		margin-top: 10px;
		padding: 10px 0;
	}

	.share_cell {
		width: 345px;
		padding-left: 15px;
		padding-right: 15px;
		position: relative;
	}

	.share_bg {
		display: block;
		width: 345px;
		height: 125px;
	}

	.amount_money {
		position: absolute;
		right: 20px;
		top: 20px;
		font-size: 35px;
		width: 125px;
		text-align: center;
	}

	.amount_money span {
		font-size: 20px
	}

	.font_size_f {
		font-size: 20px
	}


	.tabcontentcell {
		padding: 0 15px;
	}

	.con_b {
		padding: 48px 0 100px;
	}

	.con_b_normal {
		padding: 48px 0 50px;
	}

	.cella {
		width: 375px;
		height: 187.5px;
	}

	.cover_image {
		width: 375px;
		height: 187.5px;
		position: relative;
	}

	.mask {
		position: absolute;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: rgba(0, 0, 0, .1);
		padding: 10px 15px;
	}


	.img_bottom {
		height: 25px;
		line-height: 25px;
		border-radius: 25px;
		border: 1px solid #38f;
		padding: 5px 20px;
		text-align: center;
		letter-spacing: 1px;
	}

	.detail_top {
		width: 345px;
		background-color: #fff;
		padding: 10px 15px;
	}

	.detail_title {
		font-size: 17px;
		line-height: 24px;
		letter-spacing: 1px;
	}

	.detail_sketch {
		margin: 5px auto 0;
		line-height: 19px;
		width: 100%;
	}

	.tips_list {
		width: 100%;
		flex-wrap: wrap;
		padding-top: 12px;
	}

	.tips_item {
		border-radius: 5px;
		padding: 4px 10px;
		margin-right: 12px;
		margin-bottom: 8px;
	}

	.book_details {
		padding-top: 10px;
		padding-bottom: 10px;
	}

	.detail_comment_list {
		padding-bottom: 10px;
	}

	.book_bottom {
		position: fixed;
		left: 0;
		bottom: 0;
		z-index: 999;
	}

	.buyBookAbout {
		border-top: 1px solid #eee;
		height: 50px;
		background-color: #fff;
		width: 360px;
		padding: 0 0 0 15px;
	}

	.tobuy_a,
	.tobuy_b {
		width: 105px;
		height: 50px;
		line-height: 50px;
		text-align: center;
	}

	.tobuy_a {
		background-color: #fc1e1e;
	}

	.tobuy_b {
		background-color: #fd7405;
	}


	.left_price {
		width: 150px;
		flex-direction: column;
		height: 50px;
	}

	.rightbtns {
		width: 210px;
	}

	// 购物车悬浮
	.cartcell {
		position: fixed;
		right: 15px;
		bottom: 120px;
		width: 40px;
		height: 40px;
		border-radius: 20px;
		background-color: #Fff;
	}

	.carticon {
		display: block;
		width: 40px;
		height: 40px;
		border-radius: 20px;
	}

	.cartnumber {
		position: absolute;
		min-width: 20px;
		top: 0;
		left: -45%;
		transform: translateX(50%);
	}

	.tab_item {
		position: relative;
		height: 40px;
		line-height: 40px;
	}

	.active {
		color: #3b7bfd;
	}

	.active::after {
		content: "";
		width: 25px;
		height: 3px;
		background-color: #3b7bfd;
		border-radius: 1.5px;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}

	.detail_comment_list_item {
		width: 345px;
		border-bottom: 1px solid #eee;
		padding: 15px 0;
		position: relative;
	}

	.detail_comment_list_deleteMask {
		background-color: rgba(255, 255, 255, .6);
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		z-index: 9;
	}

	.detail_comment_list_deleteMask img {
		width: 100px;
		height: 100px;
		display: block;
	}

	.detail_comment_list_userinfo {
		width: 345px;
		height: 40px;
		margin-bottom: 10px;
	}

	.detail_comment_list_userinfo img {
		width: 40px;
		height: 40px;
		border-radius: 20px;
	}

	.detail_comment_list_userright {
		width: 290px;
		height: 40px;
		flex-direction: column;
	}

	.detail_comment_list_txt {
		letter-spacing: 1px;
		line-height: 1.4;
		white-space: pre-wrap;
	}

	.detail_comment_list_imgs {
		width: 100%;
		flex-wrap: wrap;
		padding-top: 12px;
	}

	.detail_comment_list_img_item {
		margin-right: 15px;
		margin-bottom: 10px;
		width: 105px;
		height: 105px;
	}

	.detail_comment_list_img_item:nth-child(3n) {
		margin-right: 0 !important;
	}

	.detail_comment_list_img_item img {
		width: 105px;
		height: 105px;
		display: block;
		overflow: hidden;
		object-fit: cover;
	}

	.detail_comment_list_btns {
		padding-top: 10px;
	}

	.detail_comment_list_btns img {
		display: block;
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}

	.padding_top_b {
		padding: 15px 0;
	}
</style>